import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { getSessionCountry } from '/@/store/session/selectors';

import Title from '/@/v3/components/title';

import styles from './styles.module.css';

@connect((state) => {
    return {
        country: getSessionCountry(state),
    };
})
@autobind
export default class OldCatalogProduct extends Component {
    static propTypes = {
        brand: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        onClickProduct: PropTypes.func,
        color: PropTypes.oneOf([
            'dark',
            'light',
            'primary-corn',
            'primary-soy',
            'primary-corn-light-1',
            'primary-soy-light-1',
            'primary-dark-2',
            'secondary',
        ]),
        sizeTitle: PropTypes.oneOf(['xxl', 'xl', 'lg', 'md']),
    };

    static defaultProps = {
        color: 'primary-dark-2',
        sizeTitle: 'xl',
    };

    getLabelConfig(profile) {
        if (this.props.profile.newProduct) return { type: 'newProduct', text: _('Nuevo producto') };
    }

    render() {
        const { brand, profile, onClickProduct, color, sizeTitle, country } = this.props;
        const { id, product, shortDescription } = profile;
        const imageStyles = product.catalogImage
            ? { backgroundImage: `url('${profile.product.catalogImage}')` }
            : undefined;

        const labelConfig = this.getLabelConfig(profile);

        return (
            <div>
                {labelConfig && <div className={styles[`${labelConfig.type}`]}>{labelConfig.text}</div>}
                <div
                    className={classNames(
                        styles.product,
                        styles[brand.type],
                        styles[`theme-${brand.theme}`],
                        this.props.country.code === 'MX' ? styles.productMx : ''
                    )}
                    onClick={onClickProduct ? () => onClickProduct(id) : undefined}
                >
                    <div
                        className={classNames(
                            styles.image,
                            this.props.country.code === 'MX' ? styles.imageMx : styles.image,
                            this.props.country.code === 'MX' ? styles.mxCard : ''
                        )}
                        style={imageStyles}
                    />

                    <div
                        className={classNames(styles.content, this.props.country.code === 'MX' ? styles.contentMx : '')}
                    >
                        <div className={styles.blur} />
                        <div
                            className={classNames(
                                styles.glass,
                                settings.app.theme !== 'cultivio'
                                    ? styles.glassGreen
                                    : styles[`glass-${brand.type}-${country.code}`]
                            )}
                        >
                            <Title size={sizeTitle} color={color} bolder>
                                {_(product.catalogName)}
                            </Title>
                            {shortDescription && (
                                <Title size='md' bolder className={styles.shortDescription}>
                                    {_(shortDescription)}
                                </Title>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
